export function PageHeader({ title, subtitle, actions }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
      gap: 16, marginBottom: 32, flexWrap: 'wrap',
    }}>
      <div>
        <h1 className="font-display" style={{
          fontSize: 34, fontWeight: 600, margin: 0, color: 'var(--ink)', lineHeight: 1.05,
        }}>{title}</h1>
        {subtitle && (
          <p style={{
            margin: '8px 0 0', color: 'var(--muted)', fontSize: 14, maxWidth: 640, lineHeight: 1.5,
          }}>{subtitle}</p>
        )}
      </div>
      {actions && <div style={{ display: 'flex', gap: 8 }}>{actions}</div>}
    </div>
  );
}
